<template>
  <div>
    <ul class="list" v-show="!play.url">
      <li class="item" v-for="i in lives" :key="i.url" @click="item_click(i)">
        <!-- <div class="badge"> -->
        <!-- <span>回放</span> -->
        <!-- </div> -->
        <img :src="i.avatar? i.avatar+ 'hd' : i.cover" class="cover" />
        <img :src="i.avatar? i.avatar+ 'hd' : i.cover" class="avatar" />
        <span class="username">{{ i.title }}</span>
      </li>
    </ul>
    <div class="play" v-show="play.url">
      <img :src="play.avatar? play.avatar+ 'hd' : play.cover" class="avatar" />
      <video v-if="isLive" id="flv" ref="video" :src="play.url"></video>
      <video
        v-if="!isLive"
        ref="video"
        preload="auto"
        :src="play.url"
        @click="video_play"
      ></video>
      <img
        src="@/assets/video_play.png"
        class="play-icon"
        @click="video_play"
        v-show="play_icon"
      />
    </div>
  </div>
</template>
<script>
// import { shost } from '@/utils'
import flvjs from "flv.js";
import axios from "axios";
export default {
  name: "live-list",
  data() {
    return {
      live: [
        // {
        //   id: '1',
        //   cover: require('@/assets/1.jpeg'),
        //   url: require('@/assets/1.mp4'),
        //   name: '怪咖逗比'
        // },
        // {
        //   id: '2',
        //   cover: require('@/assets/2.jpeg'),
        //   url: require('@/assets/2.mp4'),
        //   name: '安初夏'
        // },
        // {
        //   id: '3',
        //   cover: require('@/assets/3.jpeg'),
        //   url: require('@/assets/3.mp4'),
        //   name: '余生共挽'
        // },
        // {
        //   id: '4',
        //   cover: require('@/assets/4.jpeg'),
        //   url: require('@/assets/4.mp4'),
        //   name: '小米（夕阳红）'
        // },
        // {
        //   id: '5',
        //   cover: require('@/assets/5.jpeg'),
        //   url: require('@/assets/5.mp4'),
        //   name: '小小唐呀'
        // },
        // {
        //   id: '6',
        //   cover: require('@/assets/6.jpeg'),
        //   url: require('@/assets/6.mp4'),
        //   name: '余生共挽'
        // },
        // {
        //   id: '7',
        //   cover: require('@/assets/7.jpeg'),
        //   url: require('@/assets/7.mp4'),
        //   name: '初遇'
        // },
        // {
        //   id: '8',
        //   cover: require('@/assets/8.jpeg'),
        //   url: require('@/assets/8.mp4'),
        //   name: '安初夏'
        // },
        // {
        //   id: '1606181963639087',
        //   cover: require('@/assets/1606181963639087.jpeg'),
        //   url: require('@/assets/1606181963639087.mp4'),
        //   name: '阿澍'
        // }
      ],
      play: {},
      play_icon: true,
      isLive: false,
    };
  },
  created() {
    axios.get("http://sm-icp.taowoapp.com/api/live/web_list/").then((resp) => {
      this.live.push(...resp.data.data.list)
      // console.log(resp.data)
    });
  },
  computed: {
    lives() {
      return this.live;
      // let s = shost()
      // if (s === 1) {
      //   return this.live.filter((e) => e.url < 5)
      // } else if (s === 2) {
      //   return this.live.filter((e) => e.url > 4)
      // } else {
      //   return []
      // }
    },
  },
  methods: {
    video_play() {
      let video = this.$refs.video;
      if (video.paused) {
        video.play();
        this.play_icon = false;
      } else {
        video.pause();
        this.play_icon = true;
      }
    },
    item_click(item) {
      // this.$message({
      //   message: '请下载app观看直播',
      //   type: 'warning'
      // })
      if (item.url.endsWith(".mp4")) {
        this.play = item;
        this.isLive = false;
      } else {
        this.isLive = true;
        this.$nextTick(() => {
          let videoElement = document.getElementById("flv");

          if (flvjs.isSupported()) {
            var flvPlayer = flvjs.createPlayer({
              type: "flv",
              url: item.url,
            });

            flvPlayer.attachMediaElement(videoElement);

            flvPlayer.load(); //加载
          }
        });
      }
      this.play = item;
    },
    reset() {
      let video = this.$refs.video;
      if (!video.paused) video.pause();
      this.play = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  padding: 0;
  margin-bottom: 0;
  .item {
    display: inline-block;
    position: relative;
    margin-right: 50px;
    margin-bottom: 30px;
  }
}
.badge {
  position: absolute;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 1);
  background: rgba(0, 0, 0, 0.3);
  right: 10px;
  top: 20px;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
}
.cover {
  width: 300px;
  height: 225px;
  display: block;
  margin-bottom: 10px;
  object-fit: cover;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.username {
  font-size: 14px;
  line-height: 40px;
  vertical-align: top;
  margin-left: 10px;
}
.play {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .avatar {
    margin-bottom: 15px;
  }
  &-icon {
    position: absolute;
    width: 50px;
    height: 50px;
  }
}
video {
  outline: none;
  max-height: 600px;
}
</style>
